// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollToTop_wrapper__cD1Fh","wrapper__content":"ScrollToTop_wrapper__content__bRBVY","visible":"ScrollToTop_visible__rPuuY"};